import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({ baseURL });

// Attach Bearer token to every outgoing request (if logged in)
http.interceptors.request.use((config) => {
  const STORAGE_KEY = "mygenie_auth";
  const REMEMBER_KEY = "mygenie_remember";
  try {
    const remember = localStorage.getItem(REMEMBER_KEY) === "true";
    const store = remember ? localStorage : sessionStorage;
    const raw = store.getItem(STORAGE_KEY);
    if (raw) {
      const { token } = JSON.parse(raw);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } catch {
    /* ignore */
  }
  return config;
});

// On 401, clear auth and redirect to login
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("mygenie_auth");
      localStorage.removeItem("mygenie_remember");
      sessionStorage.removeItem("mygenie_auth");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default http;
